// 🔹 Backend Base URL
const BASE =
  process.env.REACT_APP_API_URL?.replace(/\/$/, "") ||
  "https://newtownbunglow.in/api";



/**
 * 🔹 Common fetch wrapper (safe JSON + error handling)
 */

function getDomainWithMainPath() {
  const domain = window.location.hostname.replace("www.", "");
  const segment = window.location.pathname.split("/")[1];
  return segment ? `${domain}/${segment}` : domain;
}
async function request(url, options = {}) {
  try {
    const res = await fetch(url, options);

    let data;
    try {
      data = await res.json();
    } catch {
      data = null;
    }

    if (!res.ok) {
      throw new Error(data?.error || `Request failed: ${res.status}`);
    }

    return data;
  } catch (err) {
    console.error("API Error:", err.message);
    throw err;
  }
}

/**
 * 🔹 Fetch project by domain
 */
export async function fetchProject() {
  return request(`${BASE}/project-by-domain`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "x-domain": getDomainWithMainPath(),
      "x-path": window.location.pathname + window.location.search ,
    },
  });
}


/**
 * 🔹 Fetch loan partners
 */
export async function fetchLoanPartners() {
  return request(`${BASE}/loans`);
}

/**
 * 🔹 Send OTP
 */
export async function sendOtp(payload) {
  return request(`${BASE}/leads/send-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-domain": getDomainWithMainPath(),
    },
    body: JSON.stringify(payload),
  });
}

/**
 * 🔹 Verify OTP
 */
export async function verifyOtp(payload) {
  return request(`${BASE}/leads/verify-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-domain": getDomainWithMainPath(),
    },
    body: JSON.stringify(payload),
  });
}

/**
 * 🔹 Get next unique ID
 */
export async function getNextUid() {
  try {
    // ✅ STEP 1: check existing ID
    const existing = localStorage.getItem("lead_unique_id");
    if (existing) return existing;

    // ✅ STEP 2: get new from backend
    const data = await request(`${BASE}/leads/next-uid`);
    const uid = String(data?.unique_id || Date.now());

    // ✅ STEP 3: store it
    localStorage.setItem("lead_unique_id", uid);

    return uid;
  } catch {
    // fallback
    const uid = String(Date.now());
    localStorage.setItem("lead_unique_id", uid);
    return uid;
  }
}

/**
 * 🔥 Uploads URL builder (FIXED + SAFE)
 */
export function uploadsUrl(projectId, filename) {
  const base =
    process.env.REACT_APP_UPLOADS_URL?.replace(/\/$/, "") ||
    "https://microsite.thehomestore.co.in/uploads";

  if (!filename) return "";

  // If already prefixed like "2_logo.webp", don't double add projectId
  if (filename.startsWith(`${projectId}_`)) {
    return `${base}/${filename}`;
  }

  // Default: prepend projectId
  return `${base}/${projectId}_${filename}`;
}